import { Link } from "react-router-dom";
import type { Work } from "@/types/catalog";
import { WORK_TYPE_LABEL } from "@/types/catalog";

interface WorkCardProps {
  work: Work;
  className?: string;
}

export default function WorkCard({ work, className = "" }: WorkCardProps) {
  return (
    <Link
      to={`/detail/${work.type}/${work.id}`}
      className={`group block cursor-pointer ${className}`}
    >
      <div
        data-product-shop
        className="relative w-full overflow-hidden rounded-lg bg-background-100"
        style={{ aspectRatio: "3 / 4" }}
      >
        <img
          src={work.cover}
          alt={`${work.title}封面`}
          title={`${work.title} - 爱妻艺影视推荐`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-medium text-background-50">
          {WORK_TYPE_LABEL[work.type]}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-0.5 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-semibold text-background-50">
          <i className="ri-star-fill text-accent-400"></i>
          {work.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 to-transparent p-3 pt-8">
          <p className="line-clamp-2 text-sm font-medium text-background-50">{work.title}</p>
          <p className="mt-0.5 text-xs text-background-200">
            {work.year} · {work.region}
          </p>
        </div>
      </div>
      <p className="mt-2 line-clamp-1 text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
        {work.title}
      </p>
      <p className="mt-1 flex flex-wrap gap-1">
        {work.genres.slice(0, 2).map((genre) => (
          <span
            key={genre}
            className="rounded-sm bg-secondary-100 px-1.5 py-0.5 text-xs text-secondary-900"
          >
            {genre}
          </span>
        ))}
      </p>
    </Link>
  );
}